import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "file_a1433450031b7607023813a110d0c7b9",
  "use": "file_a1433450031b7607023813a110d0c7b9-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"file_a1433450031b7607023813a110d0c7b9\">\n    <path fill-rule=\"evenodd\" d=\"M7.346 2v3.333c0 .92.732 1.667 1.635 1.667h3.269v5.667A1.32 1.32 0 0 1 10.942 14H5.058a1.32 1.32 0 0 1-1.308-1.333V3.333A1.32 1.32 0 0 1 5.058 2h2.288zm.98 0l3.924 4H8.98a.66.66 0 0 1-.653-.667V2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol